import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS } from '../../../../../../../types';
import { riskScoreSearchSchema } from '../../index';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/risk-score/edit/$projectionId/')({
  validateSearch: zodValidator(riskScoreSearchSchema),
  beforeLoad: ({ context, preload }) => {
    const isAllowed = context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.RISK_SCORE });
    context.validatePermissions({ isAllowed, preload });
  },
});
